import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MAT_DIALOG_DATA } from '@angular/material';
import { MeasureNumDenumaretor } from 'src/app/models/IEncounterReport';

export interface DialogData {
  measureName: string;
  patMeasureList: MeasureNumDenumaretor[];
}

@Component({
  selector: 'app-auto-measure-patient-info',
  templateUrl: './auto-measure-patient-info.component.html',
  styleUrls: ['./auto-measure-patient-info.component.css']
})
export class AutoMeasurePatientInfoComponent implements OnInit {


  @ViewChild("passwordfocus", { static: false }) passwordfocus: ElementRef;
  type: boolean;
  measuretype: string;
  constructor(public dialogRef: MatDialogRef<AutoMeasurePatientInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
  }
  public MesuresList: MeasureNumDenumaretor[];
  columnsToDisplay2: string[] = ['PatientId', 'PatientName', 'ProviderName', 'LocationName'];

  dataSource = new MatTableDataSource<MeasureNumDenumaretor>();
  ngOnInit() {
    this.dataSource.data = this.data.patMeasureList;
    this.measuretype = this.data.measureName;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  PatEleAcdisplayedColumns: string[] = ['DenCriteria', 'RecteptNum', 'TransmitNum'];
  displayedColumns: string[] = ['DCNonContr', 'DCContr', 'NumNonContr', 'NumContr', 'DrugFormula'];
  displayedColumnsed: string[] = ['DenCriteria', 'TransmitNum', 'RecteptNum'];
  displayedColumnss: string[] = ['DReportPer', 'numofElectronic', 'ElectronicSummaryCare', 'AllergyReconOccurred', 'Electronic'];


}
export interface DialogData {
  inputValue: string;
  headerText: string;
  inputType: string;
}
